import React, { useState } from 'react'
import styled from 'styled-components'
import userChatIcon from 'static/icons/user_chat_blue.svg'
import attachmentIcon from 'static/icons/attachment.svg'
import { Input } from 'app/components/ui/form/Input'
import { Button } from 'app/components/ui/Button'
import { ChatMessageSend } from '.'
import { getFileFromInputEvent } from 'app/utils/file'
import { InputFile } from 'app/components/ui/form/InputFile'
import { Text } from 'app/components/ui/Text'
import { themeEstra } from 'app/styles/themeEstra'
import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { formatDateToApiIsoString } from 'app/utils/date'

interface Props {
  fileToUpload: File | null
  showFileInput: boolean
  fileValidationError: string | null
  onFileSelected: (file: File | null) => void
  onSendMessage: (message: ChatMessageSend) => void
  toggleShowFileInput: () => void
  className?: string
}

export const ChatToolbar: React.FC<Props> = ({
  onSendMessage,
  onFileSelected,
  toggleShowFileInput,
  fileToUpload,
  showFileInput,
  fileValidationError,
  className,
}) => {
  const [message, setMessage] = useState('')

  return (
    <>
      <ChatToolbarWrapper className={className}>
        <img src={userChatIcon} alt='user' height='40px'></img>
        {showFileInput ? (
          <>
            <InputFileWrapper>
              <InputFile
                name={'ChatInput'}
                selectedFileName={fileToUpload?.name}
                onChange={e => {
                  const file = getFileFromInputEvent(e)

                  onFileSelected(file)
                }}
                OnClearInput={() => onFileSelected(null)}
              />
              <Text
                variant='s12'
                color={themeEstra.color.primari.grigioEstra}
                mt={0.5}
                isItalic
              >
                Dimensione massima del file 10 MB
              </Text>
              {fileValidationError ? (
                <FormFeedback variant='error'>
                  {fileValidationError}
                </FormFeedback>
              ) : null}
            </InputFileWrapper>
            <Button
              variant={fileToUpload ? 'ciano' : 'grigio'}
              type='button'
              onClick={() => {
                if (fileToUpload) {
                  onSendMessage({
                    file: fileToUpload,
                    type: 'file',
                    sent_at: formatDateToApiIsoString(new Date()) as string,
                  })
                  onFileSelected(null)
                }
                toggleShowFileInput()
              }}
            >
              <Text variant='s14' weight='400'>
                {fileToUpload ? 'Invia' : 'Scrivi'}
              </Text>
            </Button>
          </>
        ) : (
          <Input
            placeholder='Aggiungi un commento...'
            value={message}
            type='text'
            onConfirm={() => {
              if (!message.trim().length) return
              onSendMessage({
                message: message,
                type: 'text',
                sent_at: formatDateToApiIsoString(new Date()) as string,
              })
              setMessage('')
            }}
            onChange={value => {
              setMessage(value as string)
            }}
            sideButton={
              <Button
                variant='grigio'
                type='button'
                onClick={() => toggleShowFileInput()}
              >
                <img src={attachmentIcon} alt='attach_file' width='20px' />
              </Button>
            }
          ></Input>
        )}
      </ChatToolbarWrapper>
    </>
  )
}

const ChatToolbarWrapper = styled.div`
  display: flex;
  padding: 1rem 2rem;

  @media (max-width: ${themeEstra.bp.desktop}) {
    padding: 1rem;
  }

  & > img {
    margin-right: 0.5rem;
  }

  & > button {
    margin-left: 0.5rem;
  }
`

const InputFileWrapper = styled.div`
  flex: 1;
`
